import React, { Component } from 'react';
import { connect } from 'react-redux';
import intl from 'react-intl-universal';
import { push } from 'redux-first-history';
import { addToHistory } from 'src/utils/utilsActions';
import { uploadBatchInitiations, downloadBatchTemplate, getBatchInitProgress, showHideErrorDialog } from '../state/serviceInitActions';
import { ServiceBatchPres } from '../presentational/ServiceBatchPres';
import { PageTitle } from 'src/ui/library/PageTitle';
import {
  SERVICEINIT_URL_ADDSI,
  SI_BATCH_SUPPORTED_FILES,
  SI_BATCH_UPLOAD_TOTAL_MAX_SIZE,
  SI_BATCH_PROGRESS_INTERVAL,
  SERVICEINIT_URL,
} from 'src/constants/constants.js';
import { fnIsDefaultOldView } from 'src/helpers/commonFunctions';

class ServiceInitBatchContainer extends Component {
  state = {
    initType: '',
    csvFiles: [],
    rejected: [],
    uploadedSize: 0,
    progress: null,
    del: [],
    enableDel: false,
    intervalId: null,
  };

  componentDidMount() {}

  handleInitTypeChange = value => {
    if (value === 'individual') {
      this.setState({ initType: value });
      this.props.push(SERVICEINIT_URL_ADDSI);
      if (!fnIsDefaultOldView()) window.location.href = SERVICEINIT_URL_ADDSI;
    } else {
      this.setState({ initType: value });
    }
  };

  toggleDelete = (i, e) => {
    const del = this.state.del.slice();
    let enableDel = false;

    del[i] = e.target.checked;

    for (let i of del) {
      if (i) {
        enableDel = true;
      }
    }

    this.setState({ del, enableDel });
  };

  delUpload = e => {
    e.preventDefault();

    const { del, csvFiles } = this.state;

    let toRemove = [];
    for (let i = 0; i < del.length; i++) {
      if (del[i]) {
        toRemove.push(i);
      }
    }

    this.setState({
      csvFiles: csvFiles.filter((value, index) => {
        return !toRemove.includes(index);
      }),
      del: del.filter((value, index) => {
        return !toRemove.includes(index);
      }),
      enableDel: false,
    });
  };

  attachFiles = (files, rejectedFiles) => {
    const del = this.state.del.slice();
    //597942: To override the previously uploaded file
    this.setState({ csvFiles: [] });
    const { uploadedSize, csvFiles, rejected } = this.state;
    let newUploadTotalSize = uploadedSize;

    // Limit number of files
    if (csvFiles.length >= 1) return;

    files.forEach((file, index) => {
      newUploadTotalSize += file.size;
      if (newUploadTotalSize <= SI_BATCH_UPLOAD_TOTAL_MAX_SIZE) {
        csvFiles.push(file);

        del.push(false);
      } else {
        newUploadTotalSize -= file.size;
        rejected.push(file);
      }
    });

    this.setState(prevState => ({
      uploadedSize: newUploadTotalSize,
      rejected,
      csvFiles,
      del,
    }));
  };

  removeUnsupportedFile(file) {
    let remaining = this.state.rejected.reduce((total, current) => (current !== file ? [...total, current] : total), []);
    this.setState({ rejected: remaining, progress: 0 });
  }

  submit = () => {
    const { csvFiles } = this.state;
    const { uploadBatchInitiations } = this.props;
    const { startProgressListener } = this;
    uploadBatchInitiations(csvFiles[0], importId => {
      startProgressListener(importId);
    });
  };

  startProgressListener = importId => {
    const { getBatchInitProgress } = this.props;

    // Check progress every 3 seconds
    var intervalId = setInterval(
      () =>
        getBatchInitProgress(importId, () => {
          clearInterval(intervalId);
        }),
      SI_BATCH_PROGRESS_INTERVAL,
    );
  };

  isDisabled = () => {
    const { csvFiles } = this.state;
    if (!csvFiles.length) {
      return true;
    }

    return false;
  };

  downloadTemplate = () => {
    this.props.downloadBatchTemplate();
  };

  closeErrorDialog = () => {
    this.props.showHideErrorDialog(false);
    const { errors } = this.props;
    if (errors && errors.length === 0) {
      this.props.history.push(SERVICEINIT_URL);
    }
  };

  render() {
    return (
      <React.Fragment>
        <PageTitle title={intl.get('serviceInit.addInit.pageTitle')} />
        <ServiceBatchPres
          initType={this.state.initType}
          onChangeInitType={this.handleInitTypeChange}
          attachFiles={this.attachFiles}
          progress={this.state.progress}
          csvFiles={this.state.csvFiles}
          rejected={this.state.rejected}
          acceptedFileTypes={SI_BATCH_SUPPORTED_FILES.join(',')}
          removeUnsupportedFile={file => this.removeUnsupportedFile(file)}
          submit={this.submit.bind(this)}
          isDisabled={this.isDisabled()}
          maxSize={SI_BATCH_UPLOAD_TOTAL_MAX_SIZE}
          toggleDelete={this.toggleDelete}
          delUpload={this.delUpload}
          enableDel={this.state.enableDel}
          downloadTemplate={this.downloadTemplate}
          closeErrorDialog={this.closeErrorDialog}
          {...this.props}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  showSpinner: state.serviceInit.isLoadingBatch,
  importId: state.serviceInit.importId,
  importStatus: state.serviceInit.importStatus,
  importProgress: state.serviceInit.importProgress,
  showErrors: state.serviceInit.showErrors,
  errors: state.serviceInit.errors,
  successCountwithRows: state.serviceInit.successCountwithRows,
  failureCountwithRows: state.serviceInit.failureCountwithRows,
});

const mapDispatchToProps = {
  push,
  addToHistory,
  uploadBatchInitiations,
  downloadBatchTemplate,
  getBatchInitProgress,
  showHideErrorDialog,
};

export default connect(mapStateToProps, mapDispatchToProps)(ServiceInitBatchContainer);
